var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseButton',_vm._g(_vm._b({staticClass:"text-red-500 text-lg flex-1 h-full hover:bg-yellow-300 dark-hover:bg-gray-800\n  md:h-72p md:border md:rounded-lg md:w-full md:px-6 md:flex-none md:mb-8",class:{
    'md:bg-red-500 md:border-transparent md:hover:bg-red-400 md:text-white': _vm.primary,
    'md:bg-white md:border-red-300 md:hover:bg-yellow-200 md:dark:bg-transparent md:dark:border-red-800': !_vm.primary,
  }},'BaseButton',_vm.$attrs,false),_vm.$listeners),[_c('div',{staticClass:"flex items-center justify-center w-full h-full md:justify-start",class:{
      'flex-col md:flex-row': _vm.vertical,
    }},[_c(_vm.icon,{tag:"component",class:[
        _vm.vertical ? 'mb-1 md:mb-0 md:mr-4': 'mr-4'
      ]}),_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }